<script lang="ts" setup>
import { NxtFormSection, NxtDropdown } from '@future-harry/nxt-styles';
import { Language } from '@future-harry/nxt-vue-library';

defineProps<{
   userInfo: any;
   languagesOptions: any[];
}>();

const emits = defineEmits<{
   'change-language': [language: Language];
}>();
</script>

<template>
   <NxtFormSection :title="$t('settings.general-user-settings')">
      <section class="settings-form-layout">
         <div class="row">
            <div class="col-half">
               <NxtDropdown
                  :model-value="userInfo?.language.id"
                  :class="'col-4'"
                  :label="$t('job-board.settings.language')"
                  :has-clear-option="false"
                  :search-type="'none'"
                  :name="'teams'"
                  :emit-object="true"
                  :options="languagesOptions"
                  @update:model-value="emits('change-language', $event)"
               />
            </div>
         </div>
      </section>
   </NxtFormSection>
</template>

<style lang="scss" scoped>
.settings-form-layout {
   width: 100%;
}
</style>
